export const categories = [
  { slug: "romance", name: "恋爱言情", icon: "ri-heart-line", count: 128 },
  { slug: "fantasy", name: "奇幻冒险", icon: "ri-magic-line", count: 96 },
  { slug: "action", name: "热血动作", icon: "ri-fire-line", count: 87 },
  { slug: "comedy", name: "搞笑日常", icon: "ri-emotion-laugh-line", count: 74 },
  { slug: "thriller", name: "悬疑惊悚", icon: "ri-ghost-line", count: 53 },
  { slug: "drama", name: "都市剧情", icon: "ri-building-line", count: 65 },
  { slug: "historical", name: "古风历史", icon: "ri-ancient-gate-line", count: 42 },
  { slug: "bl", name: "BL专区", icon: "ri-user-heart-line", count: 91 },
];

export const featuredComics = [
  {
    id: 1,
    slug: "duzhe-yu-nvzhu",
    title: "读者与女主的正确关系",
    author: "金作家",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20couple%20in%20a%20manga%20cover%20art%20style%2C%20soft%20warm%20lighting%2C%20elegant%20character%20design%2C%20clean%20minimal%20background%20with%20pastel%20pink%20tones%2C%20professional%20digital%20art%2C%20webtoon%20cover%20quality&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    rating: 9.5,
    views: "1280万",
    status: "连载中",
    description: "穿越到小说世界后，我发现自己是那个注定悲剧的女配角。为了改变命运，我决定远离所有主角……但他为什么总是出现在我身边？",
    chapters: 67,
    updatedAt: "2026-08-05",
    isHot: true,
  },
  {
    id: 2,
    slug: "diyi-xuemei",
    title: "第一学妹",
    author: "李画师",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20style%20illustration%20of%20a%20cheerful%20schoolgirl%20with%20bright%20expression%2C%20manga%20cover%20art%20style%2C%20vibrant%20colors%2C%20clean%20white%20background%20with%20soft%20yellow%20accents%2C%20professional%20digital%20illustration%2C%20comic%20cover%20quality&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    rating: 9.2,
    views: "986万",
    status: "连载中",
    description: "全校第一的学霸学妹，私下里却是个超级游戏宅！当这个秘密被学长发现后，两个人的校园生活彻底改变了……",
    chapters: 45,
    updatedAt: "2026-08-04",
    isHot: true,
  },
  {
    id: 3,
    slug: "jiansheng-wang",
    title: "剑圣王",
    author: "朴漫画家",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20style%20illustration%20of%20a%20swordsman%20in%20dynamic%20action%20pose%2C%20dark%20atmospheric%20background%20with%20blue%20energy%20effects%2C%20professional%20manga%20cover%20art%2C%20webtoon%20quality%2C%20intense%20lighting&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    rating: 9.7,
    views: "1560万",
    status: "连载中",
    description: "被世人嘲笑的废柴剑士，在获得上古剑圣传承后，踏上了一条逆天改命的道路。一剑破万法，我自逍遥！",
    chapters: 89,
    updatedAt: "2026-08-05",
    isHot: true,
  },
  {
    id: 4,
    slug: "mojie-shiwusuo",
    title: "魔界事务所",
    author: "崔编剧",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20mystical%20Korean%20manhwa%20cover%20illustration%20of%20magical%20characters%20in%20a%20fantasy%20world%2C%20purple%20and%20gold%20color%20scheme%2C%20elegant%20art%20style%2C%20clean%20minimal%20background%2C%20professional%20webtoon%20cover%20quality&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    rating: 9.3,
    views: "1120万",
    status: "已完结",
    description: "隐藏在都市中的魔界事务所，专门处理人类与魔族的纠纷。新来的实习律师却发现，自己的委托人们都不是人类……",
    chapters: 120,
    updatedAt: "2026-07-20",
    isHot: false,
  },
  {
    id: 5,
    slug: "tianmi-chengfa",
    title: "甜蜜惩罚",
    author: "郑漫画",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20romance%20manhwa%20cover%20illustration%20of%20a%20couple%20in%20embrace%2C%20soft%20pink%20and%20peach%20color%20palette%2C%20romantic%20atmosphere%2C%20clean%20simple%20background%2C%20professional%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    rating: 9.1,
    views: "890万",
    status: "连载中",
    description: "因为一次意外，冷酷总裁不得不娶了一个普通女孩。本以为是场交易婚姻，却在朝夕相处中慢慢沦陷……",
    chapters: 55,
    updatedAt: "2026-08-03",
    isHot: false,
  },
  {
    id: 6,
    slug: "yinying-lieren",
    title: "阴影猎人",
    author: "吴漫画家",
    category: "thriller",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20mysterious%20Korean%20manhwa%20cover%20illustration%20of%20a%20detective%20character%20in%20shadows%2C%20noir%20style%2C%20high%20contrast%20lighting%2C%20clean%20minimal%20dark%20background%2C%20professional%20webtoon%20cover%20quality&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    rating: 9.4,
    views: "760万",
    status: "连载中",
    description: "首尔连续发生离奇失踪案件，退役特种兵金泰浩成为私家侦探后，发现所有线索都指向一个不存在的组织……",
    chapters: 38,
    updatedAt: "2026-08-04",
    isHot: false,
  },
];

export const latestUpdates = [
  {
    id: 7,
    slug: "xingkong-xia-de-qiyue",
    title: "星空下的契约",
    author: "韩画师",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20starry%20night%20Korean%20manhwa%20cover%20illustration%20of%20two%20characters%20under%20stars%2C%20romantic%20and%20dreamy%20atmosphere%2C%20soft%20blue%20and%20purple%20tones%2C%20clean%20minimal%20background%2C%20webtoon%20quality&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    rating: 8.9,
    views: "320万",
    status: "连载中",
    latestChapter: "第42话 - 流星雨的约定",
    updatedAt: "2小时前",
  },
  {
    id: 8,
    slug: "zhi-ming-youxi",
    title: "致命游戏",
    author: "姜作家",
    category: "thriller",
    cover: "https://readdy.ai/api/search-image?query=A%20suspenseful%20Korean%20manhwa%20cover%20illustration%20of%20characters%20in%20a%20game%20setting%2C%20tense%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20clean%20minimal%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    rating: 9.0,
    views: "540万",
    status: "连载中",
    latestChapter: "第28话 - 最后的幸存者",
    updatedAt: "3小时前",
  },
  {
    id: 9,
    slug: "chong-sheng-zhi-lu",
    title: "重生之路",
    author: "闵漫画家",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20illustration%20of%20a%20character%20with%20glowing%20energy%2C%20rebirth%20theme%2C%20mystical%20golden%20light%2C%20clean%20minimal%20background%2C%20professional%20webtoon%20cover%20quality&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    rating: 9.6,
    views: "1450万",
    status: "连载中",
    latestChapter: "第103话 - 命运的转折",
    updatedAt: "5小时前",
  },
  {
    id: 10,
    slug: "xiaoyuan-mishi",
    title: "校园秘事",
    author: "白画师",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=A%20fun%20Korean%20school%20comedy%20manhwa%20cover%20illustration%20of%20students%20laughing%2C%20bright%20and%20colorful%20style%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover%20quality&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    rating: 8.7,
    views: "670万",
    status: "连载中",
    latestChapter: "第56话 - 文化祭大作战",
    updatedAt: "6小时前",
  },
  {
    id: 11,
    slug: "guzhuang-qiyuan",
    title: "古装奇缘",
    author: "陈漫画家",
    category: "historical",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20historical%20Korean%20manhwa%20cover%20illustration%20of%20characters%20in%20traditional%20hanbok%2C%20elegant%20classical%20style%2C%20soft%20warm%20tones%2C%20clean%20minimal%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    rating: 9.3,
    views: "890万",
    status: "连载中",
    latestChapter: "第71话 - 宫廷风波",
    updatedAt: "8小时前",
  },
  {
    id: 12,
    slug: "dushi-lieren",
    title: "都市猎人",
    author: "安作家",
    category: "drama",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20urban%20Korean%20manhwa%20cover%20illustration%20of%20a%20cool%20character%20in%20city%20setting%2C%20stylish%20and%20trendy%2C%20clean%20minimal%20background%2C%20professional%20webtoon%20cover%20quality&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    rating: 8.8,
    views: "430万",
    status: "连载中",
    latestChapter: "第34话 - 黑夜追踪",
    updatedAt: "10小时前",
  },
  {
    id: 13,
    slug: "mo-wang-de-xinniang",
    title: "魔王的新娘",
    author: "柳画师",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20fantasy%20Korean%20manhwa%20cover%20illustration%20of%20a%20beautiful%20bride%20and%20dark%20lord%2C%20gothic%20romance%20style%2C%20deep%20red%20and%20black%20tones%2C%20clean%20minimal%20background%2C%20webtoon%20quality&width=400&height=560&seq=comic-cover-13&orientation=portrait",
    rating: 9.4,
    views: "1020万",
    status: "连载中",
    latestChapter: "第88话 - 真心的告白",
    updatedAt: "12小时前",
  },
  {
    id: 14,
    slug: "reyue-quanji",
    title: "热血拳击",
    author: "郑漫画家",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20sports%20Korean%20manhwa%20cover%20illustration%20of%20a%20boxer%20in%20action%2C%20intense%20and%20powerful%20style%2C%20clean%20minimal%20background%2C%20professional%20webtoon%20cover%20quality&width=400&height=560&seq=comic-cover-14&orientation=portrait",
    rating: 8.6,
    views: "380万",
    status: "连载中",
    latestChapter: "第25话 - 决胜之拳",
    updatedAt: "14小时前",
  },
];

export const hotRankings = [
  { rank: 1, title: "剑圣王", slug: "jiansheng-wang", trend: "up", change: 0 },
  { rank: 2, title: "重生之路", slug: "chong-sheng-zhi-lu", trend: "up", change: 1 },
  { rank: 3, title: "读者与女主的正确关系", slug: "duzhe-yu-nvzhu", trend: "down", change: -1 },
  { rank: 4, title: "魔界事务所", slug: "mojie-shiwusuo", trend: "up", change: 2 },
  { rank: 5, title: "魔王的新娘", slug: "mo-wang-de-xinniang", trend: "down", change: -1 },
  { rank: 6, title: "阴影猎人", slug: "yinying-lieren", trend: "up", change: 1 },
  { rank: 7, title: "古装奇缘", slug: "guzhuang-qiyuan", trend: "new", change: 0 },
  { rank: 8, title: "第一学妹", slug: "diyi-xuemei", trend: "down", change: -2 },
  { rank: 9, title: "甜蜜惩罚", slug: "tianmi-chengfa", trend: "up", change: 3 },
  { rank: 10, title: "致命游戏", slug: "zhi-ming-youxi", trend: "new", change: 0 },
];

export const banners = [
  {
    id: 1,
    slug: "jiansheng-wang",
    title: "剑圣王 - 热血回归！第90话更新",
    description: "被世人嘲笑的废柴剑士，获得上古传承后逆天改命！一剑破万法，见证剑圣的传奇之路！",
    image: "https://readdy.ai/api/search-image?query=A%20dramatic%20epic%20fantasy%20scene%20with%20a%20swordsman%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20landscape%2C%20golden%20sunset%20lighting%2C%20sword%20glowing%20with%20energy%2C%20inspirational%20and%20powerful%20atmosphere%2C%20painterly%20digital%20art%20style%2C%20cinematic%20composition%2C%20warm%20orange%20and%20gold%20tones&width=1600&height=700&seq=banner-01&orientation=landscape",
    badge: "🔥 热门推荐",
  },
  {
    id: 2,
    slug: "duzhe-yu-nvzhu",
    title: "读者与女主 - 浪漫穿越之旅",
    description: "穿越到小说世界成为女配，本想远离主角改变命运，但命运的齿轮已经开始转动……",
    image: "https://readdy.ai/api/search-image?query=A%20romantic%20fantasy%20scene%20with%20elegant%20characters%20in%20a%20palace%20garden%2C%20cherry%20blossoms%20falling%2C%20soft%20pastel%20pink%20and%20gold%20lighting%2C%20dreamy%20atmosphere%2C%20painterly%20digital%20art%2C%20cinematic%20composition&width=1600&height=700&seq=banner-02&orientation=landscape",
    badge: "💕 新作推荐",
  },
  {
    id: 3,
    slug: "chong-sheng-zhi-lu",
    title: "重生之路 - 突破100话里程碑",
    description: "命运交织的奇幻世界，主角一路披荆斩棘。第103话「命运的转折」震撼上线！",
    image: "https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20rebirth%20scene%20with%20a%20character%20surrounded%20by%20mystical%20golden%20light%2C%20ascending%20towards%20the%20sky%2C%20dramatic%20clouds%2C%20powerful%20and%20inspirational%20atmosphere%2C%20painterly%20digital%20art%2C%20cinematic%20composition&width=1600&height=700&seq=banner-03&orientation=landscape",
    badge: "⭐ 里程碑",
  },
];

export const articleContent = {
  slug: "duzhe-yu-nvzhu",
  title: "读者与女主的正确关系",
  author: "金作家",
  category: "恋爱言情",
  categorySlug: "romance",
  status: "连载中",
  rating: 9.5,
  views: "1280万",
  favorites: "86.5万",
  description: "穿越到小说世界后，我发现自己是那个注定悲剧的女配角。为了改变命运，我决定远离所有主角……但他为什么总是出现在我身边？",
  cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20couple%20in%20a%20manga%20cover%20art%20style%2C%20soft%20warm%20lighting%2C%20elegant%20character%20design%2C%20clean%20minimal%20background%20with%20pastel%20pink%20tones%2C%20professional%20digital%20art%2C%20webtoon%20cover%20quality&width=400&height=560&seq=comic-cover-01&orientation=portrait",
  longDescription: `平凡的女大学生林晓月，在一次意外中穿越到了自己正在追的言情小说《月光下的恋人》中。

然而，她并没有成为那个集万千宠爱于一身的女主角，而是成为了小说中注定悲剧收场的女配角——白若涵。

在原作中，白若涵因为嫉妒女主而不断使坏，最终落得家破人亡的下场。知道剧情的林晓月决定彻底改变命运：远离所有主角，安安稳稳地活到大结局。

可是她万万没想到，当她刻意避开男主角的时候，那位高高在上的男主大人却主动找上门来……

"白若涵，你为什么躲着我？"

面对男主的质问，林晓月只想说：我不是躲你，我是在躲剧情啊！

一场充满意外与笑料的穿越之旅，就此展开。当读者变成了故事中的人物，她能否改写既定的命运？而那个本应属于女主的爱情，又是否会因为她这只蝴蝶的翅膀而改变方向？`,
  tags: ["穿越", "恋爱", "喜剧", "女配逆袭", "甜宠"],
  chapters: [
    { number: 1, title: "第一话 - 意外穿越", date: "2025-03-15", isFree: true },
    { number: 2, title: "第二话 - 我是女配角？！", date: "2025-03-22", isFree: true },
    { number: 3, title: "第三话 - 远离主角计划", date: "2025-03-29", isFree: true },
    { number: 4, title: "第四话 - 初见男主", date: "2025-04-05", isFree: true },
    { number: 5, title: "第五话 - 命运的交汇", date: "2025-04-12", isFree: true },
    { number: 6, title: "第六话 - 他为什么在这里", date: "2025-04-19", isFree: true },
    { number: 7, title: "第七话 - 午后的偶遇", date: "2025-04-26", isFree: true },
    { number: 8, title: "第八话 - 心跳加速", date: "2025-05-03", isFree: true },
    { number: 9, title: "第九话 - 女主的登场", date: "2025-05-10", isFree: true },
    { number: 10, title: "第十话 - 微妙的气氛", date: "2025-05-17", isFree: true },
    { number: 11, title: "第十一话 - 宴会风波", date: "2025-05-24", isFree: true },
    { number: 12, title: "第十二话 - 意外的舞伴", date: "2025-05-31", isFree: false },
    { number: 13, title: "第十三话 - 月光下的对话", date: "2025-06-07", isFree: false },
    { number: 14, title: "第十四话 - 秘密花园", date: "2025-06-14", isFree: false },
    { number: 15, title: "第十五话 - 你的名字", date: "2025-06-21", isFree: false },
    { number: 67, title: "第六十七话 - 命运的选择", date: "2026-08-05", isFree: false },
  ],
};

export const allComics = [...featuredComics, ...latestUpdates];

export const getComicsByCategory = (categorySlug: string) => {
  return allComics.filter((c) => c.category === categorySlug);
};

export const getComicBySlug = (slug: string) => {
  return allComics.find((c) => c.slug === slug);
};